import React from 'react';
import { Layer } from '../Popup/style';

export default props => {
    return (
        <>
            <Layer
                style={{ zIndex: 1000 }}
            />
        </>
    );
}